import React from "react";
import FormInputs from "../../../../../../components/UI/FormInputs";
import { isSet,getCss } from "../../../../../../utils/commonUtils";




const BasicFormFields = (props)=>{

    const {
      itemIndex,
      column,
      label,
      labelWrap,
      labelStyle,
      rangeMin,
      rangeMax,
      name,
      formData,
      changeHandler,
      defaultValue,
      isLabel,
      appendElmtClass,
      validation,
      required,
      layout,
      showContainerBorder
    } = props;
    let value = isSet(formData[name],isSet(defaultValue,''));
    if(name){
      try {
        if(name.includes('.')){
          let newName=eval("formData." +name)
          value = newName;
         }
      } catch (error) {
        console.log("error");
        
      }
      
    }
    let otherArributes = {...getCss(name,value)};
    if((isSet(rangeMin,null)!==null && value<rangeMin) || isSet(rangeMax,null)!==null && value>rangeMax){
      otherArributes={
        ...otherArributes,
        style:{color:'red'}
      }
    }
    
    // Evaluate required function if it's a function
    let evaluatedRequired = required;
    if (typeof required === 'function') {
      try {
        evaluatedRequired = required(formData);
      } catch (error) {
        console.error('Error evaluating required function:', error);
        evaluatedRequired = false;
      }
    }
    
    const labelWrapCls = (labelWrap===true)?'text-truncate':'';
    const isStackedLayout = layout === 'stacked';
    const borderCls = showContainerBorder ? 'border border-left-0' : '';
    const formGroupCls = isStackedLayout ? 'form-group mb-0' : 'form-group row mb-0 align-items-center';
    const labelCls = isStackedLayout
      ? `f-400  px-2 text-sm ${labelWrapCls} mb-1 opacity-75 d-block`
      : `col-sm-6 f-400 text-sm ${labelWrapCls} mb-0 opacity-75`;
    const inputWrapperCls = (isSet(isLabel,true)===false)
      ? `col-sm-12 ${appendElmtClass || ''}`.trim()
      : (isStackedLayout ? `col-12 ${appendElmtClass}` : `col-sm-6 ${appendElmtClass}`);
    let reload =''
    if (name === 'injection_name' && formData?.injection_name) {
      reload = formData.injection_name
    } else if (name === 'medication_name' && formData?.medication_name) {
      reload = formData.medication_name
    } else if (formData['lab_id']!=null) {
      reload=formData['lab_id']
    }
    const textTypesForMax = props.type === 'TextInput' || props.type === 'NewTextInput';
    const resolvedMax = textTypesForMax && props.max == null && props.Max != null ? props.Max : props.max;
    const formInputProps = textTypesForMax && resolvedMax != null
      ? { ...props, max: resolvedMax }
      : props;
    return(
      <>
        <div className={`${column} ${borderCls} py-1`} key={itemIndex}>
        <div className={formGroupCls}>
          {isSet(isLabel,true)===false?
          <></>
          :<label className={labelCls} title={label} style={labelStyle}>  {label}  </label>}
           
           <div className={inputWrapperCls}>
              <FormInputs 
                {...formInputProps}
                {...otherArributes}
                required={evaluatedRequired}
                value={value}
                reload={reload}
                validation={validation}
                name={name}
                changeHandler={(val,{addressParam = {},autoPopulates={}} = {})=>{
                  changeHandler(name,val,{...addressParam,...autoPopulates})} }/>
                {
                  (isSet(validation[name], "") !== "" ? (
                      <span className="text-danger m-1">
                        {isSet(validation[name], "")}
                      </span>
                    ) : (
                      ""
                    ))
                }
                  
                
           </div>
        </div>
     </div> 
     </>
    )
}

BasicFormFields.defaultProps = {
   defaultValue:null,
   isLabel:true,
   appendElmtClass:'',
   access:true,
   rangeMax:null,
   rangeMin:null,
   labelWrap:true,
   layout:'inline',
   showContainerBorder:true,
   validation:{}
}
export default BasicFormFields;
